import { TCountryCode } from "../../constants";

export type sightUnit = {
  date: string;
  count: number;
};

export type DataType = {
  property: string;
  value: string | number;
};

export type ITopProduct = {
  userId: string;
  asin: string;
  lookupId: string;
  title: string | null;
  imageURL: string | null;
  countryCode: TCountryCode;
  salePrice: number;
  costPrice: number;
  fulfilmentType: string | null;
  fbmCost: number | null;
  storageTime: number | null;
  minimumRoi: number | null;
  minimumProfit: number | null;
  preparationFee: number | null;
  inboundShipping: number | null;
  inboundPlacementService: number | null;
  miscellaneousFee: number | null;
  miscellaneousFeePercent: number | null;
  totalDiscount: number | null;
  multipackQuantity: number | null;
  quantity: number | null;
  profit: number | null;
  roi: number | null;
  bsr: number | null;
  estSales: number | null;
  breakeven: number | null;
  profitPercentage: number | null;
};

export interface DashboardProps {
  loadingDashboardInsight: boolean;
  analyzerData: sightUnit[];
  scannerData: sightUnit[];
  loadingTopProducts: boolean;
  topProducts: ITopProduct[];
}

export const initialState: DashboardProps = {
  loadingDashboardInsight: false,
  analyzerData: [],
  scannerData: [],
  topProducts: [],
  loadingTopProducts: false,
};
